import { connect } from 'react-redux';
import App from './app.component';

const mapStateToProps = ({ app }) => ({
  authType: app?.config?.authType,
});

export default connect(mapStateToProps)(App);
